// extracted by mini-css-extract-plugin
export default {"sticky":"layout_column_sticky_x"};